import { render, staticRenderFns } from "./DataConfigurationCustomColumnDialog.vue?vue&type=template&id=7bef0f28"
import script from "./DataConfigurationCustomColumnDialog.vue?vue&type=script&lang=js"
export * from "./DataConfigurationCustomColumnDialog.vue?vue&type=script&lang=js"
import style0 from "./DataConfigurationCustomColumnDialog.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports